import React, { useEffect, useState } from 'react';
import Axios from 'axios';
import { storage } from '../../utils';
import utils from '../../components/toastify/toastify';

const stamp = (value, time = false) => new Intl.DateTimeFormat(time ? 'en-GB' : 'fa-IR', {
  timeZone: 'Asia/Tehran',
  ...(time ? { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false } : { year: 'numeric', month: '2-digit', day: '2-digit' }),
}).format(new Date(value));

export function ConsultationLeads() {
  const [result, setResult] = useState({ data: [], products: [], total: 0, pages: 1 });
  const [page, setPage] = useState(1);
  const [q, setQ] = useState('');
  const [product, setProduct] = useState('');
  const [filters, setFilters] = useState({ q: '', product_id: '' });
  const [loading, setLoading] = useState(true);
  const [exporting, setExporting] = useState(false);
  const [error, setError] = useState(false);
  useEffect(() => {
    let active = true;
    setLoading(true); setError(false);
    const load = async () => {
      try {
        const token = await storage.load('token');
        const { data } = await Axios.get('/get_consultation_leads', { params: { ...filters, page }, headers: { 'x-auth': token } });
        if (active) setResult(data);
      } catch (_) { if (active) setError(true); }
      finally { if (active) setLoading(false); }
    };
    load();
    return () => { active = false; };
  }, [filters, page]);
  const download = async (format) => {
    setExporting(true);
    try {
      const token = await storage.load('token');
      const response = await Axios.get('/export_consultation_leads', { params: { ...filters, format }, headers: { 'x-auth': token }, responseType: 'blob' });
      const url = URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url; link.download = `consultation-leads.${format}`;
      document.body.appendChild(link); link.click(); link.remove();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch (_) { utils.showAlert('دریافت خروجی انجام نشد', 'error'); }
    finally { setExporting(false); }
  };
  return <div className="content-body" dir="rtl"><section className="card"><div className="card-header"><h4>درخواست‌های مشاوره رایگان</h4><span>{result.total.toLocaleString('fa-IR')} درخواست</span></div><div className="card-body">
    <p className="text-muted">تاریخ و ساعت تمام درخواست‌ها به وقت تهران است. خروجی شامل تمام نتایج فیلترشده است.</p>
    <form className="d-flex flex-wrap mb-2" style={{ gap: 10 }} onSubmit={(event) => { event.preventDefault(); setPage(1); setFilters({ q, product_id: product }); }}>
      <input aria-label="جستجوی درخواست‌ها" className="form-control" style={{ width: 250, maxWidth: '100%' }} value={q} onChange={(event) => setQ(event.target.value)} placeholder="نام، موبایل یا عنوان محصول" />
      <select aria-label="محصول یا دوره" className="form-control" style={{ width: 280, maxWidth: '100%' }} value={product} onChange={(event) => setProduct(event.target.value)}><option value="">همه محصولات و دوره‌ها</option>{result.products.map((item) => <option key={item._id} value={item._id}>{item.title}</option>)}</select>
      <button className="btn btn-primary" type="submit" disabled={loading}>جستجو</button>
      <button className="btn btn-outline-success" type="button" onClick={() => download('xlsx')} disabled={exporting || loading || error}>خروجی اکسل</button>
      <button className="btn btn-outline-secondary" type="button" onClick={() => download('csv')} disabled={exporting || loading || error}>خروجی CSV</button>
    </form>
    {loading ? <p role="status">در حال دریافت درخواست‌ها…</p> : error ? <p role="alert">دریافت اطلاعات انجام نشد. دوباره تلاش کنید.</p> : <div className="table-responsive"><table className="table"><thead><tr><th>محصول / دوره</th><th>نام و نام خانوادگی</th><th>شماره موبایل</th><th>تاریخ درخواست (تهران)</th><th>ساعت درخواست (تهران)</th></tr></thead><tbody>{result.data.length ? result.data.map((item) => <tr key={item._id}><td>{item.product_title}</td><td>{item.name}</td><td dir="ltr"><a href={`tel:${item.phone_number}`}>{item.phone_number}</a></td><td>{stamp(item.creation_date)}</td><td dir="ltr">{stamp(item.creation_date, true)}</td></tr>) : <tr><td colSpan="5" className="text-center">درخواستی با این مشخصات ثبت نشده است.</td></tr>}</tbody></table></div>}
    <div className="d-flex align-items-center" style={{ gap: 12 }}><button className="btn btn-light" disabled={page <= 1 || loading} onClick={() => setPage(page - 1)}>قبلی</button><span>صفحه {page.toLocaleString('fa-IR')} از {result.pages.toLocaleString('fa-IR')}</span><button className="btn btn-light" disabled={page >= result.pages || loading} onClick={() => setPage(page + 1)}>بعدی</button></div>
  </div></section></div>;
}
